import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DatosService,crearReport } from 'src/app/services/DatosService.service';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-calificaciones-report',
  templateUrl: './calificaciones-report.component.html',
  styleUrls: ['./calificaciones-report.component.css']
})
  
export class CalificacionesReportComponent implements OnInit {
reporte:crearReport={

  asignaturasx:false,
  submodulosx:false,
  extracurricularesx:false,
  periodo:null,
  plantel:null,
  docente:'',
  todosdocentes:false

  };

  asignaturas:boolean=false;
  submodulos:boolean=false;
  extracurriculares:boolean=false;
  todos:boolean=false;
  docentes:boolean=false;

  datosReporte:any=[];
  datosReporteTodo:any=[];
  periodos:any=[];
  planteles:any=[];
  getdocentes:any=[];


  datosReporteAsigySub:any[];
  datosReporteExtracurriculares:any[];

  API_URI = environment.uri_api;

  numplantel:number;
  nombreplantel:number;
  verinputplantel:boolean=false;
  vercomboplantel:boolean=false;

  constructor( private traer:DatosService,private msj:mensajeSesionExpiradaService,private router:Router) { }

  ngOnInit(): void {

    let datos = JSON.parse(localStorage.getItem('datos'));
    this.numplantel=datos.idplantel;
   

    if(this.numplantel==0){

      this.verinputplantel=false;
      this.vercomboplantel=true;

      this.getplanteles();
      this.getDocentes(); 

    }else if(this.numplantel != 0){

      this.nombreplantel=datos.idplantel;
      this.verinputplantel=true;
      this.vercomboplantel=false;

      this.getDocentes2(); 
      this.reporte.plantel=this.numplantel;
      this.nombreplantel=datos.plantel;
      console.log(this.reporte.plantel);
    }

    this.getperiodos();

  }

  testCheckAsignaturas(event:any){
    console.log(event.target.checked); 
    this.asignaturas= event.target.checked;

    if(this.asignaturas==true){
      this.extracurriculares=false;

      this.reporte.extracurricularesx=false;

    }else if(this.asignaturas==false){
      this.todos=false;
      this.reporte.extracurricularesx=false;
    }

  }

  testCheckSubmodulos(event:any){
    console.log(event.target.checked); 
    this.submodulos= event.target.checked;

    if(this.submodulos==true){
      this.extracurriculares=false;

      this.reporte.extracurricularesx=false;

    }else if(this.submodulos==false){
      this.todos=false;
      this.reporte.extracurricularesx=false;
    }

  }

  testCheckExtracurriculares(event:any){
    console.log(event.target.checked);
    this.extracurriculares= event.target.checked;

    if(this.extracurriculares==true){
      console.log("entro");
      this.asignaturas=false;
      this.submodulos=false;

      this.reporte.asignaturasx=false;
      this.reporte.submodulosx=false;

    }else if(this.extracurriculares==false){
      this.todos=false;
    }

  }

  testCheckTodos(event:any){
    console.log(event.target.checked);
    this.todos= event.target.checked;

    if(this.todos==true){
      
    this.reporte.asignaturasx=true;
    this.reporte.submodulosx=true;
    this.reporte.extracurricularesx=true;

    }else{
      
    this.reporte.asignaturasx=false;
    this.reporte.submodulosx=false;
    this.reporte.extracurricularesx=false;

    }

  }

  testCheckTodosDocentes(event:any){
    console.log(event.target.checked);
    this.docentes=event.target.checked;

    if(this.docentes==true){
      this.reporte.docente="";
    }

  }

  Reporte(form:NgForm){

    if(this.reporte.asignaturasx==false && this.reporte.submodulosx==false && this.reporte.extracurricularesx==false && this.todos==false){
      Swal.fire({

        title:"Información incompleta",
        icon:"warning",
        text:'Elija una opción de reporte'
  
      })
    }else{

      if(this.todos==true){

        this.ejecutarTodos();
        return;
      }

    if(form.valid && this.reporte.extracurricularesx==false){

      Swal.fire({
        title: "Esta operación podría tomar algun tiempo",
        text: "¡Por favor sea paciente!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok, entendido",
        cancelButtonText:"Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {  

    this.traer.http.post(this.API_URI+'/generarExcel',this.reporte)
    .subscribe((res:any)=>{

      console.log(res);
      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

      this.datosReporte=res.datos;

      console.log(this.datosReporte);
    
        let arr = this.datosReporte;
      
      let Heading = [['Matricula', 'Sexo', 'Genero','Curp','Nombre','App Paterno','App Materno','Plantel','Grupo','Ciclo','Período','Carrera','Asignatura','Claves','Núm. empleado','Primer parcial','Segundo parcial','Tercer parcial','Calificación final','Calificación extra','Calificación CI','Id período']];
    
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, Heading);

   
      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, arr, { origin: 'A3', skipHeader: true });

    
         var wscols = [
            {wch:20,}, //Matricula
            {wch:10}, //Num.Emp
            {wch:12}, //RFC
            {wch:21},  //Curp
            {wch:17}, //Nombre
            {wch:17}, //ApPaterno
            {wch:17}, //ApMaterno
            {wch:20}, //Plantel
            {wch:15}, //Grupo
            {wch:8}, //Faltas
            {wch:15}, //Sueldo
            {wch:30}, //Despensa
            {wch:60}, //Eficiencia
            {wch:27}, //CLAVES
            {wch:14}, //Lentes
            {wch:14}, //GUARDERIA
            {wch:14}, //Becas
            {wch:14}, //Canastilla
            {wch:25}, //Aparatos Ortopedicos
            {wch:23}, //Ajuste guarderia
            {wch:18}, //Total Percepciones
            {wch:12},//ISR   
        ];
        
        ws['!cols'] = wscols;
    
      XLSX.utils.book_append_sheet(wb, ws, 'Datos',true);
    
      XLSX.writeFile(wb,res.tipolista+'.xlsx');


    })

      }
    });


    }else if(form.valid && this.reporte.extracurricularesx==true){


    Swal.fire({
      title: "Esta operación podría tomar algun tiempo",
      text: "¡Por favor sea paciente!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok, entendido",
      cancelButtonText:"Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {


    this.traer.http.post(this.API_URI+'/generarExcel',this.reporte)
    .subscribe((res:any)=>{

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

      this.datosReporte=res.datos;

      console.log(this.datosReporte);
    
        let arr = this.datosReporte;
      
      let Heading = [['Nombre Extracurricular', 'Nombre Docente', 'Apellido Pat.','Apellido Mat.','Núm. Empleado','Plantel','Grupo','Matricula','Nombre Alumno','Apellido Paterno','Apellido Materno','P1','Observación','P2','Observación','P3','Observación','Remediación','Observación']];
    
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, Heading);
    
      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, arr, { origin: 'A3', skipHeader: true });
    
         var wscols = [
            {wch:34,}, //Nombre Extracurricular
            {wch:12}, //Nombre Docente
            {wch:11}, //Apellido Paterno
            {wch:11},  //Apellido Materno
            {wch:9}, //Núm empleado
            {wch:15}, //Plantel
            {wch:15}, //Grupo
            {wch:17}, //Matricula
            {wch:16}, //Nom. alumno
            {wch:14}, //app paterno alumno
            {wch:14}, //app materno alumno
            {wch:8}, //P1
            {wch:21}, //Observacion
            {wch:14}, //P2
            {wch:14}, //Observacion
            {wch:14}, //P3
            {wch:14}, //Observacion
            {wch:25}, //Remediacion
            {wch:23}, //Observacion
 

        ];
        
        ws['!cols'] = wscols;
    
      XLSX.utils.book_append_sheet(wb, ws, 'Datos');
    
      XLSX.writeFile(wb,res.tipolista+'.xlsx');


    })

      }
    });
    


    }else{
    Swal.fire({

      title:"Información incompleta",
      icon:"error",
      text:'Complete los campos'

    })
    }

    }
    

  }

  getperiodos(){

    var t=localStorage.getItem('token');
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });


    this.traer.http.get(this.API_URI+'/getPeriodos',{headers:httpHeaders})
    .subscribe((res:any)=>{

      console.log(res);
      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();  
        return; 
    }

      this.periodos=res;
    });

  }

  getplanteles(){

    this.traer.http.get(this.API_URI+'/getPlanteles')
    .subscribe((res:any)=>{

      console.log(res);

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

console.log(res); 
res.shift();
      this.planteles=res;
    });

  }

  getDocentes(){

    this.traer.http.get(this.API_URI+'/getDocentes')
    .subscribe((res:any)=>{

      console.log(res);

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion(); 
        return;  
    }

    console.log(res); 
      this.getdocentes=res;
    });

  }

getDocentes2(){

    this.traer.http.get(this.API_URI+'/getDocentesPorplantel/${this.numplantel}',)
    .subscribe((res:any)=>{

      console.log(res);

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

    console.log(res); 
      this.getdocentes=res;
    });

  }

  quitartodosDocentes(){
    if(this.reporte.docente != ''){
      this.docentes=false;
      this.reporte.todosdocentes=false;
    }
  }

  ejecutarTodos(){

        Swal.fire({
      title: "Esta operación podría tomar algun tiempo",
      text: "¡Por favor sea paciente!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok, entendido",
      cancelButtonText:"Cancelar"
    }).then((result) => {

      if (result.isConfirmed) {

    this.traer.http.post(this.API_URI+'/generarExcelTodos',this.reporte)
    .subscribe((res:any)=>{

      console.log(res);

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion(); 
        return;  
    }

      this.datosReporte=res.datos;
      this.datosReporteTodo=res.extracurri;

      console.log(res.extracurri);
    
        let arr = this.datosReporte;
        let arrextra=this.datosReporteTodo;
      
      let Heading = [['Matricula', 'Sexo', 'Genero','Curp','Nombre','App Paterno','App Materno','Plantel','Grupo','Ciclo','Período','Carrera','Asignatura','Claves','Núm. empleado','Primer parcial','Segundo parcial','Tercer parcial','Calificación final','Calificación extra','Calificación CI','Id período']];
      let Heading2 = [['Nombre Extracurricular', 'Nombre Docente', 'Apellido Pat.','Apellido Mat.','Núm. Empleado','Plantel','Grupo','Matricula','Nombre Alumno','Apellido Paterno','Apellido Materno','P1','Observación','P2','Observación','P3','Observación','Remediación','Observación']];
    
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, Heading);

      const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws2, Heading2);

      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, arr, { origin: 'A3', skipHeader: true });
      XLSX.utils.sheet_add_json(ws2, arrextra, { origin: 'A3', skipHeader: true });
    
         var wscols = [
            {wch:20,}, //
            {wch:10}, //
            {wch:12}, //
            {wch:21},  //
            {wch:17}, //
            {wch:17}, //
            {wch:17}, //
            {wch:20}, //
            {wch:15}, //
            {wch:8}, //
            {wch:15}, //
            {wch:30}, //
            {wch:60}, //
            {wch:27},// Clavex
            {wch:14}, //
            {wch:14}, //
            {wch:14}, //
            {wch:14}, //
            {wch:25}, //
            {wch:23}, //
            {wch:18}, //
            {wch:12},// 
        ];

        var wscols2 = [
          {wch:20,}, //Nombre Extracurri
          {wch:10}, //Num.Emp
          {wch:12}, //RFC
          {wch:21},  //Curp
          {wch:17}, //Nombre

        ];
        
        ws['!cols'] = wscols;
        ws2['!cols'] = wscols2;
    
      XLSX.utils.book_append_sheet(wb, ws, 'Asignaturas y Submódulos',true);
      XLSX.utils.book_append_sheet(wb, ws2, 'Extracurriculares',true);
      
      XLSX.writeFile(wb,res.tipolista+'.xlsx');


    })

  }

});

  }

}